import { render } from "./NoOrder.vue?vue&type=template&id=0d3222c7"
import script from "./NoOrder.vue?vue&type=script&lang=js"
export * from "./NoOrder.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_955269ba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__